import { TLang } from 'src/constants/langs'

interface ITextBtn {
    lang: TLang
    text: string
}

export const textBtn: ITextBtn[] = [
    {
        lang: 'en',
        text: 'CLAIM BONUS',
    },
    {
        lang: 'de',
        text: 'BONUS BEANSPRUCHEN',
    },
    {
        lang: 'ro',
        text: 'OBȚINEȚI BONUSUL',
    },
    {
        lang: 'es',
        text: 'OBTENER BONO',
    },
    {
        lang: 'fr',
        text: 'RÉCLAMER LE BONUS',
    },
    {
        lang: 'it',
        text: 'RICHIEDERE IL BONUS',
    },
    {
        lang: 'pt',
        text: 'RESGATAR BÔNUS',
    },
    {
        lang: 'el',
        text: 'ΑΠΑΙΤΗΣΗ ΤΟΥ ΜΠΟΝΟΥΣ',
    },
    {
        lang: 'sl',
        text: 'PREVZEMI BONUS',
    },
]
